import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_AccommodationchecklistListComponent from "../components/_FM_accommodationchecklist/_FM_AccommodationchecklistListComponent";
import _FM_AccommodationchecklistFormComponent from "../components/_FM_accommodationchecklist/_FM_AccommodationchecklistFormComponent";
import _FM_AccommodationchecklistShowComponent from "../components/_FM_accommodationchecklist/_FM_AccommodationchecklistShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_AccommodationchecklistPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();

  useEffect(() => {
    document.title = t('accommodationchecklist') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/accommodation-readiness-checklist')
  }, []);

  return (
    <div className="_FM_AccommodationchecklistPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/accommodation-readiness-checklist"}/>
      <Panel>
        <_FM_AccommodationchecklistListComponent />
      </Panel>
      <Sidebar position="right" visible={action === 'create' || action === 'update'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <_FM_AccommodationchecklistFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={id && action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <_FM_AccommodationchecklistShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_AccommodationchecklistPage);
